<template>
    <button :class="'mj-btn-' + type + ' btn-' + type" class="btn" @click="$emit('click')">{{text}}</button>
</template>

<script>
    export default {
        name: "MJButton",
        props: {
            text: {
                type: String,
                required: true
            },
            type: {
                type: String,
                default: "primary"
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/color_palette";

    button {
        font-size: 18px;
        font-weight: 600;
        &.mj-btn-primary {
            width: 100%;
            background-color: blue("100");
            border-color: blue("100");
            &:hover {
                background-color: blue("70");
                border-color: blue("70");
            }
        }
    }
</style>